"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * zwraca liczbę reprezetującą częśc daty
 * @param date data w formacie yyyy-MM-dd HH:mm:ss
 * @param part rok:y,yy,yyy,year;
 * miesiąc:M,MM,month;
 * dzien:d,dd,day;
 * godzina:h,hh,hour;
 * minuta:m,mm,minute;
 * sekunda:s,ss,second;
 */
function datePart(date, part) {
    switch (part) {
        case 'y':
        case 'yy':
        case 'yyyy':
        case 'year':
            return _getInt(date, 0, 4);
        case 'M':
        case 'MM':
        case 'month':
            return _getInt(date, 5, 2);
        case 'd':
        case 'dd':
        case 'day':
            return _getInt(date, 8, 2);
        case 'h':
        case 'hh':
        case 'hour':
            return _getInt(date, 11, 2);
        case 'm':
        case 'mm':
        case 'minute':
            return _getInt(date, 14, 2);
        case 's':
        case 'ss':
        case 'second':
            return _getInt(date, 17, 2);
        /*
      case 'ddd': {
        return dayShort[dateParse(date).getDay()];
    
      }
      case 'dddd': {
        return dayNames[dateParse(date).getDay()];
    
      }
      case 'MMM': {
        return monthShort[dateParse(date).getMonth()];
    
      }
      case 'MMMM': {
        return monthNames[dateParse(date).getMonth()];
    
      }
      */
        default:
            return 0;
    }
}
exports.default = datePart;
function _getInt(s, start, length) {
    if (start < s.length) {
        return +s.substr(start, length);
    }
    return 0;
}
//# sourceMappingURL=datePart.js.map